import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { connect } from 'react-redux';
import Summary from '../../components/summary/index';
import Table from '../../components/table/profitlossreport';
import Portifolio from '../portfolio-x-ray/portfolio-x-ray'
import combineStyle from "../../utils/stylesheets/combainstyle/combainstyle";
import commonstyletable from "../../utils/stylesheets/table/commontablestyle";
import Transaction from '../transaction/transactionreport'
import '../../utils/stylesheets/tabs/tabs.css'
import secureStorage from '../../utils/securestorage';
import labels from '../../utils/constants/labels';
import Label from '../../utils/constants/labels';
import constants from '../../utils/constants/apiconstant';
import { RealEstateFilterChange } from '../../redux/actions/portfolioxray/portfolioxray';
import { RealEstateprofitandlossfilter, getProfitLossDetails } from '../../redux/actions/profitloss/profitlossaction'
import { bindActionCreators } from "redux";
import { realEstate_transactionfilter, } from '../../redux/actions/transaction/actions';
import { replaceNull, sortArray } from '../../utils/commonfunction';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        // <Typography>{children}</Typography>      
        <div
          style={{
            fontSize: '1rem',
            fontWeight: 400,
            lineHeight: 1.5,
            letterSpacing: '0.00938rem',
          }}
        >{children}</div>

      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}
const Styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    // backgroundColor: theme.palette.background.paper,
  },
  tabRoot: {
    "& .MuiTab-root:focus": {
      color: window.globalConfig.color.BROWN
    },
    "& .MuiTab-textColorPrimary.Mui-selected": {
      color: window.globalConfig.color.BROWN
    }
  },
  portfolioXraySevenSplitContainer: {
    display: "grid",
    gridTemplateColumns: "35% 17% 16% 16% 16% !important",
    marginLeft: 20,
    [theme.breakpoints.down("920")]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr) !important',
      gap: 1,
      gridTemplateRows: 'auto',
      paddingRight: 10,
      gridTemplateAreas: `"schemeFirstGrid  . schemeFifthGrid"
  "schemeSecondGrid . schemeSixthGrid"
  "schemeThirdGrid . investedAmountGrid"`,
      "& .schemeFourthGrid": {
        display: "none"
      }
    },
  },
  transactionContainer: {
    display: "grid",
    gridTemplateColumns: "10% 38% 10% 12% 15% 15%",
    marginLeft: "20px",
    alignContent: "center",
    [theme.breakpoints.down("920")]: {
      gridTemplateColumns: "repeat(2,1fr)",
      gridTemplateAreas: `"${"dategrid"} ${"dategrid"}"
      "${"schemegrid"} ${"schemegrid"}"
      "${"assetClassgrid"} ${"transactionTypegrid"}"
      "${"folioNumbergrid"} ${"unitgrid"}"
      "${"navgrid"} ${"amountgrid"}"`,
      padding: 10,
      gap: 10
    }
  },
  portfolioXrayCatrgorySevenSplitContainer: {
    display: "grid",
    gridTemplateColumns: "35% 17% 16% 16% 16% !important",
    // paddingLeft: "10px"
    marginLeft: "20px",
    alignContent: "center",
    [theme.breakpoints.down("920")]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr) !important',
      gridTemplateAreas: `"categorySchemeGrid categoryInvestedGrid"
      ". categoryNetpl"
     `,
    }
  },
});
const portfolioxraytitle = [{ "name": labels.Tableheader.AssetName }, { "name": labels.Tableheader.InvestedValue, "subheader": labels.Tableheader.amount }, { "name": labels.Tableheader.CurrentValue, "subheader": labels.Tableheader.Subheadingcurrent }, { "name": labels.Tableheader.unrealised, "subheader": "" }, { "name": labels.Tableheader.Net, "subheader": labels.Tableheader.SubheadingNet }]
class RealEstatTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      YearCode: "All"
    }
  }

  componentDidMount() {
    document.title = window.globalConfig.companyDetails.companyName + " - Real Estate"
    const { page, xray } = this.props;
    // 
    // console.log(page)
    //if (prev.page != page) {
    if (page.state != undefined) {
      // if (prev.page.state.tabValue != page.state.tabValue) {
      this.setState({ value: page.state.tabValue })
      // }
    }
    //}

  }

  componentDidUpdate(prev) {
    const { page } = this.props;
    // 

    if (prev.page != page) {
      if (prev.page.state != undefined) {
        if (prev.page.state.tabValue != page.state.tabValue) {
          this.setState({ value: page.state.tabValue })
        }
      }
    }
    //

  }

  onChange = (item) => {
    this.setState({ YearCode: item[0]?.label })

    this.props.getProfitLossDetails(0, this.props.logindetails.ClientID, this.props.date, this.props.date,
      this.props.date, 0, 0, this.props.logindetails.SessionID, 0, 7, 0, this.props.L5ID, 0, "", item[0]?.YearCode)
  }
  handleChange = (event, newValue) => {
    this.setState({ value: newValue })
  };
  render() {
    //   
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AppBar position="static" color="default">
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            classes={{ root: classes.tabRoot }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            TabIndicatorProps={{ style: { background: window.globalConfig.color.BROWN } }}>
            <Tab label="Summary" {...a11yProps(0)} />
            <Tab label="Portfolio X-Ray" {...a11yProps(1)} />
            <Tab label="Transactions" {...a11yProps(2)} />
            <Tab label="Booked G/L" {...a11yProps(3)} />
          </Tabs>
        </AppBar>
        <TabPanel value={this.state.value} index={0}>
          <Summary CategoryAllocation={labels.summaryPage.CategoryAllocation}
            Deptdata={this.props.Deptdata}
            splitByInstrument={labels.summaryPage.splitByMarketCap}
            EquityFundSector={labels.summaryPage.EquitySector}
            flag={constants.Common.RealEstate}
            barChartData={this.props.barChartData}
            chart={this.props.chart}
            showChart={false}
            isLoadingportfolioSummary={this.props.isLoadingportfolioSummary}
            isLoadingportfolioChart={this.props.isLoadingportfolioChart}
            categorySummary={this.props.categorySummary}
            isLoadingcategorySummary={this.props.isLoadingcategorySummary}
            DonutData={this.props.DonutData}
            grandtotal={[labels.messages.grandtotal, labels.currency.rupeesymbol + this.props.grandtotalsummary, "", this.props.categorySummary.length == 0 ? "0%" : "100.0%"]}
            EquityLoading={this.props.isLoadingMarketCapEquity}
            DebtLoading={this.props.isLoadingMarketCapDebt}
            header={constants.Common.RealEstate}
            tableHeader={[Label.summaryPage.Category, Label.summaryPage.Amount, Label.summaryPage.categoryPercentage, Label.summaryPage.holdingPercentage]
            }
          />
        </TabPanel>
        {/* PORTFOLIO XRAY */}
        <TabPanel value={this.state.value} index={1}>
          <Portifolio
            flag={constants.Common.RealEstate}
            grid={classes.realEstateSixSplitContainer}

            Total={labels.ProfitLoss.Total}
            externalClasses={classes}
            MarketValue={labels.Tableheader.MarketValue}
            CurrentGain={labels.Tableheader.CurrentValue}
            amountLabel={labels.Tableheader.price}
            units={labels.Tableheader.Quantity}
            Subheadingunits={labels.Tableheader.Subheadingprice}
            InvestedValue={labels.Tableheader.InvestedValue}
            AsOn={labels.Tableheader.AsOn}
            totaltext={labels.Tableheader.totaltext}
            Sip={labels.Tableheader.Sip}
            xray={this.props.xray}
            header={'Asset'}
            List={this.props.List}
            filterSubmit={this.props.RealEstateFilterChange}
            xraysort={this.props.xraysort}
            xrayfilter={this.props.xrayfilter}
            groupXray={this.props.groupXray}
            isLoadinggroupXray={this.props.isLoadinggroupXray}
            unrealised={this.props.unrealised}
            margetvalue={this.props.margetvalue}
            investedvalue={this.props.investedvalue}
            unrealisedpercentage={this.props.unrealisedpercentage}
            catchmessage={this.props.catchmessage}
            grandtotal={this.props.grandtotal}
            grandtotalnetpl={this.props.grandtotalnetpl}
            grandtotaltotaldividend={this.props.grandtotaltotaldividend}
            grandtotalinvestmentvalue={this.props.grandtotalinvestmentvalue}
            grandtotalmarketvalue={this.props.grandtotalmarketvalue}
            grandtotalunrealised={this.props.grandtotalunrealised}
            logindetails={this.props.logindetails}
            isXrayLoading={this.props.isXrayLoading}
            Load={this.props.Load}
            TransactionLoad={this.props.TransactionLoad}
            xcelLoad={this.props.xcelLoad}
            TransactionxcelLoad={this.props.TransactionxcelLoad}
            dropdowndetails={this.props.dropdowndetails}
            title={portfolioxraytitle}
            schemeList={this.props.schemeList} />
        </TabPanel>

        {/* TRANSACTION */}
        <TabPanel value={this.state.value} index={2}>
          <Transaction grid={classes.transactionContainer}
            ReportList={this.props.financialYearsList.length == 0 ? [] : sortArray([{ label: "All", value: 0, isChecked: false }, ...this.props.financialYearsList.map((item, index) => {
              return { ...item, label: item.Year, value: index + 1, isChecked: false }
            }),], "ID", "DESC")}

            title={[{ 'name': labels.transactionSummary.date }, { 'name': labels.Tableheader.AssetName }, { 'name': labels.transactionSummary.assetClass }, { 'name': labels.transactionSummary.transactionType, "subheader": labels.transactionSummary.TransactionNature }, { 'name': labels.transactionSummary.contractno }, { 'name': labels.transactionSummary.quantity }, { 'name': labels.transactionSummary.price }, { 'name': labels.transactionSummary.amount }]}
            flag={constants.Common.RealEstate} isLoadingtransactionList={this.props.isLoadingtransactionList} L5ID={this.props.L5ID} maxDate={this.props.maxDate} minDate={this.props.minDate}
            schemeName={labels.transactionSummary.scripName} TransactionxcelLoad={this.props.TransactionxcelLoad} TransactionLoad={this.props.TransactionLoad} logindetails={this.props.logindetails} catchmessage={this.props.catchmessage}
            date={this.props.date} userID={this.props.userID} clientID={this.props.clientID} sessionID={this.props.sessionID}
            transactionList={this.props.transactionList != "NA" && this.props.transactionList.length != 0 ? this.props.transactionList : []}
            dropdowntransaction={this.props.dropdowntransaction}
            List={this.props.dropdowntransaction}
            filterSubmit={this.props.realEstate_transactionfilter}
            header={"Transaction"}
            filterHeader={"Asset"}
          />
        </TabPanel>

        {/* PROFITANDLOSS */}
        <TabPanel value={this.state.value} index={3}>
          <Table header={"Asset"}
            GainValue={labels.ProfitLoss.GainValue}
            Units={labels.ProfitLoss.Size}
            SellValueLabel={labels.ProfitLoss.SellValue}
            // ReportList={this.props.financialYearsList.length == 0 ? [] : sortArray([{ label: "All", value: 0, }, ...this.props.financialYearsList.map((item, index) => {
            //   return { ...item, label: item.Year, value: index + 1 }
            // }),], "ID", "DESC")}
            YearCode={this.state.YearCode}
            onChange={this.onChange}
            PurchaseValueLabel={labels.ProfitLoss.PurchaseValue}
            // DividendValueLabel={labels.ProfitLoss.DividendValue}
            SchemeName={labels.Tableheader.AssetName}
            Total={labels.ProfitLoss.Total}
            flag={constants.Common.RealEstate}
            ProfitLoss={this.props.ProfitLoss}
            profitLossfilter={this.props.profitLossfilter}
            List={this.props.profitLossfilter}
            filterSubmit={this.props.RealEstateprofitandlossfilter}
            isLoadingProfitLoss={this.props.isLoadingProfitLoss}
            PurchaseValue={this.props.PurchaseValue}
            // DividendValue={this.props.DividendValue}
            SellValue={this.props.SellValue}
            grid={classes.FiveSplitContainer}
            glAmount={this.props.glAmount}
            GainPercentage={this.props.GainPercentage}
            isProfitLossLoading={this.props.isProfitLossLoading} />
        </TabPanel>

      </div>
    );
  }
}
const mapStateToProps = state => {
  // //
  return {

    //COMMON STATE
    sessionID: state.Login.sessionID,
    clientID: state.Login.logindetails.ClientID,
    userID: state.Login.userID,
    date: state.Login.date,
    logindetails: state.Login.logindetails,
    L5ID: state.Login.L5ID,

    //SUMMARY
    barChartData: state.Summary.realEstate_summary != undefined ? state.Summary.realEstate_summary : [],
    chart: state.Summary.realEstate_chart != undefined ? state.Summary.realEstate_chart : [],
    categorySummary: state.Summary.realEstate_categorySummary != undefined ? state.Summary.realEstate_categorySummary : [],
    isLoadingcategorySummary: state.Summary.realEstate_isLoadingcategorySummary != undefined ? state.Summary.realEstate_isLoadingcategorySummary : false,
    DonutData: state.Summary.realEstate_Donut != undefined ? state.Summary.realEstate_Donut : [],
    grandtotalsummary: state.Summary.realEstate_grandtotalIV != undefined ? state.Summary.realEstate_grandtotalIV : [],
    Deptdata: state.Summary.realEstate_getdeptdata,
    isLoadingportfolioChart: state.Sample.isLoadingportfolioChart,
    isLoadingportfolioSummary: state.Sample.isLoadingportfolioSummary,
    isLoadingMarketCapEquity: state.Summary.isLoadingMarketCapEquity,
    isLoadingMarketCapDebt: state.Summary.isLoadingMarketCapDebt,

    //PORTFOLIO-X-RAY
    xray: state.PortfolioXray.realEstate_xray,
    // xraysort: state.PortfolioXray.realEstate_xraysort,
    // xrayfilter: state.PortfolioXray.realEstate_xrayfilter,
    // groupXray: state.PortfolioXray.realEstate_groupXray,
    isLoadinggroupXray: state.PortfolioXray.realEstate_isXrayLoading,
    List: state.PortfolioXray.realEstate_XrayData.length == 0 ? [] : state.PortfolioXray.realEstate_XrayData.filter(
      (ele, ind) =>
        ind ===
        state.PortfolioXray.realEstate_XrayData.findIndex((elem) => elem.Scheme === ele.Scheme)
    ),
    unrealised: state.Card.mfHeader2.filter((val) => val.firstName === "Unrealised G / L (%)").map((val) => {
      return val.lastName
    }),
    margetvalue: state.Card.mfHeader2.filter((val) => val.firstName === "MF Market Value").map((val) => {
      return val.lastName
    }),
    investedvalue: state.Card.mfHeader2.filter((val) => val.firstName === "Investment Value").map((val) => {
      return val.lastName
    }),
    unrealisedpercentage: state.Card.mfHeader2.filter((val) => val.firstName === "Unrealised G / L (%)").map((item) => {
      return item.val
    }),

    logindetails: state.Login.logindetails,
    isXrayLoading: state.PortfolioXray.realEstate_isXrayLoading,

    dropdowndetails: state.Dropdown.dropdowndetails.scheme,

    // xray: state.PortfolioXray.xraysort,
    schemeList: state.PortfolioXray.realEstate_XrayData.sort(function (a, b) {
      var textA = a.Scheme.toUpperCase();
      var textB = b.Scheme.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    }),


    //TRANSACTION
    transactionList: state.transactionList.realEstate_transactionList,
    dropdowntransaction: state.transactionList.realEstate_dropdowntransaction,
    isLoadingtransactionList: state.transactionList.realEstate_isLoadingtransactionList,
    catchmessage: state.transactionList.realEstate_catchmessage,
    TransactionLoad: state.transactionList.realEstate_isLoadingPdf,
    TransactionxcelLoad: state.transactionList.realEstate_isLoadingExcel,
    minDate: state.transactionList.realEstate_minDate,
    maxDate: state.transactionList.realEstate_maxDate,

    // PROFITANDLOSS
    ProfitLoss: state.ProfitLoss.realEstate_profitLoss,
    profitLossfilter: state.ProfitLoss.realEstate_profitLossfilter,
    isLoadingProfitLoss: state.ProfitLoss.realEstate_isLoadingProfitLoss,
    PurchaseValue: state.ProfitLoss.realEstate_grandpurchasetotal,
    DividendValue: state.ProfitLoss.realEstate_granddivdend,
    SellValue: state.ProfitLoss.realEstate_grandselltotal,
    glAmount: state.ProfitLoss.realEstate_grandglamount,
    GainPercentage: state.ProfitLoss.realEstate_GainPercentage,
    isProfitLossLoading: state.ProfitLoss.realEstate_isProfitLossLoading,
    financialYearsList: replaceNull(state.Dropdown.dropdowndetails.financialYearsList, "").length != 0 ? state.Dropdown.dropdowndetails.financialYearsList : [],

  }
}
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      RealEstateFilterChange,
      realEstate_transactionfilter,
      RealEstateprofitandlossfilter,
      getProfitLossDetails
    },
    dispatch
  );
};
const mergestyles = combineStyle(Styles, commonstyletable);
export default withStyles(mergestyles)(connect(mapStateToProps, mapDispatchToProps)(RealEstatTab))